import { useWeb3React } from '@web3-react/core'
import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { ActivityBanner } from '~/components/ActivityBanner'
import { Box } from '~/components/Layout'
import {
  useGA,
  useUpdaterChainId,
  useBreakpoint,
  useNetworkValidator,
} from '~/hooks'
import { useToken } from '~/hooks/useToken'
import { useLimitSwapPair, useLimitSwapTokens } from '~/state/dex/hooks'
import { useETHBalance, useTokenBalance } from '~/state/wallet/hooks'
import { TextWrapper } from '~/theme'
import { useMemo, useLayoutEffect } from 'react'
import { WETH as WETHAddress } from '~/constants/addresses'

const StyledActivityBanner = styled(ActivityBanner)`
  width: 435px;

  a {
    text-decoration: underline;
  }
`

export const Activity = () => {
  const { t, i18n } = useTranslation()
  const { account } = useWeb3React()
  const ethBalance = useETHBalance(true)
  const chainId = useUpdaterChainId()
  const lang = i18n.resolvedLanguage === 'zh' ? 'zh-cn' : 'en-us'
  const queryAddress = WETHAddress[chainId]
  const [inputToken] = useLimitSwapPair()
  const limitSwapTokens = useLimitSwapTokens(chainId)
  const WETHOnChain = useToken(queryAddress)
  const WETH = useMemo(() => {
    return WETHOnChain ? WETHOnChain : limitSwapTokens[queryAddress]
  }, [WETHOnChain, limitSwapTokens])
  const wethBalance = useTokenBalance(account, WETH)
  const { isMobile } = useBreakpoint()
  const { trackView, trackElClick } = useGA()

  useLayoutEffect(() => {
    if (account && ethBalance && ethBalance.isZero()) {
      trackView('webtl_lo_notice', { title: t('activity_limitorder_title') })
    }

    if (
      ethBalance &&
      wethBalance &&
      wethBalance.isZero() &&
      inputToken.address === WETH?.address
    ) {
      trackView('webtl_lo_notice', { title: t('activity_weth_title') })
    }
  }, [])
  const { isArbitrum } = useNetworkValidator()

  const link = `https://support.tokenlon.im/hc/${lang}/articles/35508100689556`

  if (isArbitrum && account && ethBalance && ethBalance.isZero()) {
    return (
      <StyledActivityBanner id="limit-order-manual">
        <TextWrapper
          color="#262C4B"
          fontSize={15}
          fontWeight={500}
          lineHeight={20}
        >
          {t('activity_limitorder_title')}
        </TextWrapper>
        <Box mt={isMobile ? '4px' : '8px'}>
          <TextWrapper fontSize={12} color="#847CAE" lineHeight={'140%'}>
            <Trans i18nKey="activity_limitorder_desc">
              将资产充值至 Arbitrum 来体验限价单功能，建议优先充值
              ETH，查看充值及使用
              <a
                href={link}
                target="_blank"
                data-trackid="webtl_lo_notice_check"
                data-trackdata={JSON.stringify({
                  title: t('activity_limitorder_title'),
                  url: link,
                })}
                onClick={trackElClick}
              >
                完整教程
              </a>
              。
            </Trans>
          </TextWrapper>
        </Box>
      </StyledActivityBanner>
    )
  }

  return null
}
